import React from 'react';
import { Modal } from 'react-bootstrap';
import { formatUseYn } from '@utils/formatUseYn';

const CodeDDetailModal = ({ open, onClose, item }) => {
    return (
        <Modal show={open} onHide={onClose} centered className="md:hidden">
            <Modal.Header>
                <Modal.Title className="text-lg font-extrabold">공통코드(D) 상세</Modal.Title>
                <button type="button" className="modal-btn-close" onClick={onClose}>
                    <span className="modal-btn-span">X</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                {item ? (
                    <div className="space-y-3 text-[15px]">
                        <div className="flex items-start justify-between gap-3">
                            <div className="min-w-0">
                                <p className="text-[13px] text-gray-500">공통코드명</p>
                                <p className="font-bold text-gray-900 break-words">{item.comdName}</p>
                            </div>
                            <span className="shrink-0 font-mono text-[13px] text-gray-600">{item.comdCode}</span>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <p className="text-[13px] text-gray-500">정렬</p>
                                <p className="font-mono text-gray-900">{item.dsort}</p>
                            </div>
                            <div>
                                <p className="text-[13px] text-gray-500">사용</p>
                                <p className="font-bold text-gray-900">{formatUseYn(item.duseYn)}</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 gap-2">
                            <div>
                                <p className="text-[13px] text-gray-500">사용자정의 1</p>
                                <p className="text-gray-900 break-words">{item.usrDfn1 || '-'}</p>
                            </div>
                            <div>
                                <p className="text-[13px] text-gray-500">사용자정의 2</p>
                                <p className="text-gray-900 break-words">{item.usrDfn2 || '-'}</p>
                            </div>
                            <div>
                                <p className="text-[13px] text-gray-500">사용자정의 3</p>
                                <p className="text-gray-900 break-words">{item.usrDfn3 || '-'}</p>
                            </div>
                        </div>
                        <div>
                            <p className="text-[13px] text-gray-500">비고</p>
                            <p className="text-gray-900 whitespace-pre-wrap break-words">{item.dnotice || '-'}</p>
                        </div>
                    </div>
                ) : null}
            </Modal.Body>
        </Modal>
    );
};

export default CodeDDetailModal;
